global?.modules?.set({
  name: 'sliders',
  is_booted: false,
  async init() {
    if (this.is_booted) {
      return;
    }
    this.is_booted = true;

    // Services Slider
    initSlider({
      id: 'our-specialisations-slider',
      prevBtnId: 'our-specialisations-slider-prev',
      nextBtnId: 'our-specialisations-slider-next',
      slidesToShow: () => {
        const w = window.innerWidth;
        if (w < 640) return 1;
        if (w < 768) return 2;
        return 3;
      },
    });

    // Specialists Slider
    initSlider({
      id: 'our-specialist-slider',
      prevBtnId: 'our-specialist-slider-prev',
      nextBtnId: 'our-specialist-slider-next',
      slidesToShow: () => {
        const w = window.innerWidth;
        if (w < 640) return 1;
        if (w < 768) return 2;
        if (w < 1280) return 3;
        return 4;
      },
    });

    // Treatment Slider
    initSlider({
      id: 'dentist-office-slider',
      prevBtnId: 'dentist-office-slider-prev',
      nextBtnId: 'dentist-office-slider-next',
      slidesToShow: () => {
        const w = window.innerWidth;
        if (w < 640) return 1;
        if (w < 768) return 2;
        return 5;
      },
    });

    // Stomatology / Clinics Slider
    initSlider({
      id: 'clinics-slider',
      slidesContainerSelector: '#slides',
      prevBtnId: 'slider-prev',
      nextBtnId: 'slider-next',
      dotsSelector: '#nav-buttons button',
      slidesToShow: 1,
    });

    // SeoText Slider
    initSlider({
      id: 'slider',
      slidesContainerSelector: '#slides',
      prevBtnId: 'slider-prev',
      nextBtnId: 'slider-next',
      dotsSelector: '#nav-buttons button',
      slidesToShow: 1,
    });

    // Review Slider Desktop
    initSlider({
      id: 'arrow-slider-slides-desktop',
      prevBtnId: 'arrow-slider-slides-desktop-prev',
      nextBtnId: 'arrow-slider-slides-desktop-next',
      slidesToShow: 1,
    });

    // Review Slider Mobile
    initSlider({
      id: 'arrow-slider-slides-mobile',
      prevBtnId: 'arrow-slider-slides-mobile-prev',
      nextBtnId: 'arrow-slider-slides-mobile-next',
      slidesToShow: 1,
    });
  },
});

function initSlider(config) {
  const containers = document.querySelectorAll(`#${config.id}`);
  const prevBtns = config.prevBtnId ? document.querySelectorAll(`#${config.prevBtnId}`) : [];
  const nextBtns = config.nextBtnId ? document.querySelectorAll(`#${config.nextBtnId}`) : [];

  let dots = [];
  if (config.dotsSelector) {
    dots = document.querySelectorAll(config.dotsSelector);
  }

  containers.forEach((container, i) => {
    const instanceConfig = { ...config };
    if (prevBtns[i]) instanceConfig.prevBtn = prevBtns[i];
    if (nextBtns[i]) instanceConfig.nextBtn = nextBtns[i];

    if (config.dotsSelector) {
      let instanceDots = container.querySelectorAll(config.dotsSelector);
      if (!instanceDots.length) {
        const scope = container.closest('section') || container.parentElement;
        if (scope) instanceDots = scope.querySelectorAll(config.dotsSelector);
      }

      if (!instanceDots.length && containers.length === 1) instanceDots = dots;

      if (instanceDots.length) instanceConfig.dots = instanceDots;
    }

    new Slider(container, instanceConfig);
  });
}

class Slider {
  constructor(container, config) {
    this.container = container;
    this.config = config;

    this.slidesContainer = config.slidesContainerSelector
      ? container.querySelector(config.slidesContainerSelector)
      : container;

    this.prevBtn =
      config.prevBtn || document.getElementById(config.prevBtnId) || container.querySelector(config.prevBtnId);
    this.nextBtn =
      config.nextBtn || document.getElementById(config.nextBtnId) || container.querySelector(config.nextBtnId);

    this.dots =
      config.dots || (typeof config.dotsSelector === 'string' ? container.querySelectorAll(config.dotsSelector) : []);

    if (!this.slidesContainer) return;

    this.originalSlides = Array.from(this.slidesContainer.children);
    this.totalSlides = this.originalSlides.length;
    this.DURATION = config.duration || 400;
    this.isAnimating = false;
    this.isActive = false;
    this.offset = 0;
    this.maxSlidesInRow = 1;
    this.slideWidth = 0;

    this.handleResize = this.handleResize.bind(this);
    this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
    this.goNext = this.goNext.bind(this);
    this.goPrev = this.goPrev.bind(this);
    this.onDotClick = this.onDotClick.bind(this);

    this.init();

    window.addEventListener('resize', this.handleResize);
  }

  getMaxSlidesInRow() {
    if (typeof this.config.slidesToShow === 'function') {
      return this.config.slidesToShow();
    }
    return this.config.slidesToShow || 1;
  }

  getSlideWidth() {
    const style = getComputedStyle(this.slidesContainer);
    const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    const firstChild = this.slidesContainer.children[0];
    return firstChild ? firstChild.offsetWidth + gap : 0;
  }

  cloneSlides() {
    this.slidesContainer.innerHTML = '';

    const count = this.maxSlidesInRow;
    const firstClones = this.originalSlides.slice(0, count).map(s => s.cloneNode(true));
    const lastClones = this.originalSlides.slice(-count).map(s => s.cloneNode(true));

    this.slidesContainer.append(...lastClones, ...this.originalSlides, ...firstClones);
  }

  updateTransform(animate = true) {
    this.slidesContainer.style.transition = animate ? `transform ${this.DURATION}ms ease` : 'none';
    this.slidesContainer.style.transform = `translateX(-${this.offset * this.slideWidth}px)`;
  }

  updateVisibility() {
    if (this.totalSlides <= this.getMaxSlidesInRow()) {
      if (this.prevBtn) this.prevBtn.style.display = 'none';
      if (this.nextBtn) this.nextBtn.style.display = 'none';
      this.slidesContainer.style.transform = 'none';
      this.slidesContainer.style.transition = 'none';
      this.slidesContainer.innerHTML = '';
      this.slidesContainer.append(...this.originalSlides);
      this.isActive = false;
      return false;
    } else {
      if (this.prevBtn) this.prevBtn.style.display = '';
      if (this.nextBtn) this.nextBtn.style.display = '';
      this.isActive = true;
      return true;
    }
  }

  goToOffset(newOffset) {
    this.offset = newOffset;
    this.updateTransform(true);
  }

  goNext() {
    if (!this.isActive || this.isAnimating) return;
    this.isAnimating = true;
    this.goToOffset(this.offset + 1);
  }

  goPrev() {
    if (!this.isActive || this.isAnimating) return;
    this.isAnimating = true;
    this.goToOffset(this.offset - 1);
  }

  onDotClick(index) {
    if (!this.isActive || this.isAnimating) return;
    this.isAnimating = true;

    this.goToOffset(this.maxSlidesInRow + index);
  }

  updateDots() {
    if (!this.dots.length) return;

    let logicalIndex = this.offset - this.maxSlidesInRow;

    if (logicalIndex < 0) logicalIndex += this.totalSlides;
    logicalIndex = logicalIndex % this.totalSlides;

    this.dots.forEach((b, i) => {
      if (i === logicalIndex) b.classList.add('is-active');
      else b.classList.remove('is-active');
    });
  }

  handleTransitionEnd() {
    if (!this.isActive) return;
    this.slidesContainer.style.transition = 'none';

    const max = this.maxSlidesInRow;
    const total = this.totalSlides;

    if (this.offset >= total + max) {
      this.offset = max;
    } else if (this.offset < max) {
      this.offset = total + max - 1;
    }

    this.updateTransform(false);
    this.isAnimating = false;

    this.updateDots();
  }

  handleResize() {
    const newMax = this.getMaxSlidesInRow();
    const wasActive = this.isActive;

    this.updateVisibility();

    if (this.isActive && (!wasActive || newMax !== this.maxSlidesInRow)) {
      this.maxSlidesInRow = newMax;
      this.setupActiveState();
      return;
    }

    if (this.isActive) {
      this.slideWidth = this.getSlideWidth();
      this.updateTransform(false);
    }
  }

  setupActiveState() {
    this.cloneSlides();
    this.slideWidth = this.getSlideWidth();
    this.offset = this.maxSlidesInRow;
    this.updateTransform(false);
    this.updateDots();

    this.slidesContainer.removeEventListener('transitionend', this.handleTransitionEnd);
    this.slidesContainer.addEventListener('transitionend', this.handleTransitionEnd);
  }

  init() {
    this.maxSlidesInRow = this.getMaxSlidesInRow();
    this.updateVisibility();

    if (this.isActive) {
      this.setupActiveState();

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', this.goPrev);
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', this.goNext);
      }

      this.dots.forEach((btn, i) => {
        btn.addEventListener('click', () => this.onDotClick(i));
      });
    }
  }
}
